<template>
    <router-view :mid="$route.fullPath"/>
</template>

<script>
    export default {
        name: 'app',
    };
</script>



// WEBPACK FOOTER //
// src/App.vue